<template>
  <el-dialog :visible="visible" @update:visible="toggleVisible($event)" class="dialog" width="70%">
    <div class="head">
      <img class="qrcode" src="../../assets/img/智能批改助手公众号.jpeg">
      <div class="info">
        <div class="title">
          <img src="../../assets/img/”引号2@3x.png">
          <span>绑定微信，使用智能批改助手移动端</span>
          <img src="../../assets/img/”引号2@3x.png">
        </div>
        <div class="desc">
          <span>绑定微信，提升账户安全，并可以微信扫码登录网站，</span><br>
          <span>绑定后，您可以随时查看考试状态，接受通知。</span>
        </div>
      </div>
    </div>
    <el-row :gutter="30" class="cards">
      <el-col :span="8">
        <div class="card">
          <div class="desc">
            <div class="title">第一步：</div>
            <span>微信公众号进入“智能批改助手”。</span>
          </div>
          <img src="../../assets/img/教师绑定微信第一步.png">
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card">
          <div class="desc">
            <div class="title">第二步：</div>
            <span>输入教师帐号和密码，即可绑定账号。</span>
          </div>
          <img src="../../assets/img/教师绑定微信第二步.png">
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card">
          <div class="desc">
            <div class="title">第三步：</div>
            <span>绑定成功，可以使用微信登录智能批改助手了。</span>
          </div>
          <img src="../../assets/img/教师绑定微信第三步.png">
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean }
  },
  methods: {
    toggleVisible (visible) {
      this.$emit('update:visible', visible)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "wechat-bind-help";

.card img {
  border: 1px solid #f0f0f0;
}
</style>
